export const APPROVED = "APPROVED"
export const REJECTED = "REJECTED"